import useAuth from "hooks/useAuth";
import { createContext, useState, useContext } from "react";
import { AppGlobalContext } from "../GlobalContext";

const WinnersFiltersContext = createContext(null);

export const INITIAL_COLUMNS_STATE = {
  id: true,
  seller: true,
  sku: true,
  cost_type: true,
  usd_cost: true,
  quote: true,
  local_currency_cost: true,
  purchase_order: true,
  shipment: true,
  category_owner: true,
  country: true,
  product_type: true,
};

export default function WinnersFiltersProvider({ children }) {
  const { mainCountry } = useContext(AppGlobalContext);
  const { accessToken } = useAuth();
  const [columns, setColumns] = useState(INITIAL_COLUMNS_STATE);
  const [search, setSearch] = useState("");

  return (
    <WinnersFiltersContext.Provider
      value={{
        columns,
        setColumns,
        search,
        setSearch,
        mainCountry,
        accessToken,
      }}
    >
      {children}
    </WinnersFiltersContext.Provider>
  );
}

export const useWinnersFilters = () => {
  const context = useContext(WinnersFiltersContext);
  if (context === undefined) {
    throw new Error(
      "useWinnersFilters must be used within a WinnersFiltersProvider"
    );
  }
  return context;
};
